(function () {

    "use strict";

    function buttonActionController($rootScope) {
        var vm = this;
        
        vm.execAction = function () {
            if (!vm.isAsync) {
                vm.action();
            }
            else {
                $rootScope.activatedSave = true;
                vm.busy = true;
                vm.disable = true;
                vm.action().then(function () {
                    vm.disable = false;
                    vm.busy = false;
                    $rootScope.activatedSave = false;
                }, function () {
                    vm.disable = false;
                    vm.busy = false;
                    $rootScope.activatedSave = false;
                });
            }
        };
    }

    buttonActionController.$inject = ["$rootScope"];

    angular.module("sphforms.main")
        .component("sphFormsButtonAction", {
            controller: buttonActionController,
            bindings: {
                clas: "=",
                nameButton: "=",
                disable: "<",
                action: "=",
                isAsync: "<"
            },         
            templateUrl: "modules/main/components/ui/buttonAction/buttonAction.template.html"
        });

}());